import { render } from "./ImportComponent.vue?vue&type=template&id=1d05771f"
import script from "./ImportComponent.vue?vue&type=script&lang=js"
export * from "./ImportComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__